<template>
  <div class="confirm-check-in-info-box">
    <div class="main-container">
      <h2 class="">{{$t('page_title')}}</h2>

      <p class="about">{{ $t('about') }}</p>

      <div class="info-box">

        <div class="user-box" v-for="(customer_info, index) in customer_list" :key="`customer-${index}`">
          <div class="flex">
            <p class="info-title"><template v-if="index == 0"> ({{ $t('representative') }}){{ '\n' }}</template>{{$t('name')}}</p>
            <p class="info-item">{{customer_info.name}}</p>
          </div>

          <div class="flex">
            <p class="info-title">{{$t('sex')}}</p>
            <p class="info-item">{{sex_type[customer_info.sex]}}</p>
          </div>

          <div class="flex">
            <p class="info-title">{{$t('age')}}</p>
            <p class="info-item">{{customer_info.age}}</p>
          </div>

          <div class="flex">
            <p class="info-title">{{$t('email')}}</p>
            <p class="info-item">{{customer_info.email}}</p>
          </div>

          <div class="flex">
            <p class="info-title">{{$t('address')}}</p>
            <p class="info-item">{{customer_info.address}}</p>
          </div>

          <div class="flex">
            <p class="info-title">{{$t('tel')}}</p>
            <p class="info-item">{{customer_info.tel}}</p>
          </div>

          <div class="flex">
            <p class="info-title">{{$t('job')}}</p>
            <p class="info-item">{{customer_info.occuoation}}</p>
          </div>

          <div class="flex">
            <p class="info-title">{{$t('p_dext')}}</p>
            <p class="info-item">{{customer_info.prior_destination}}</p>
          </div>

          <div class="flex">
            <p class="info-title">{{$t('n_dext')}}</p>
            <p class="info-item">{{customer_info.next_destination}}</p>
          </div>

          <div class="flex" v-if="lang != 'ja'">
            <p class="info-title">{{$t('nationality')}}</p>
            <p class="info-item">{{customer_info.nationality}}</p>
          </div>

          <div class="flex" v-if="lang != 'ja'">
            <p class="info-title">{{$t('passport_no')}}</p>
            <p class="info-item">{{customer_info.passport_no}}</p>
          </div>

          <div class="flex" v-if="index == 0">
            <p class="info-title">{{$t('other')}}</p>
            <p class="info-item other">{{customer_info.other}}</p>
          </div>

          <div class="flex" v-if="lang != 'ja'">
            <p class="info-title">{{$t('passport_copy')}}</p>
            <p class="info-item"><img :src="customer_info.passport"></p>
          </div>
        </div>

        <div class="revise">
          <input type="checkbox" id="revise" v-model="revise">
          <label for="revise">{{ $t('revise') }}</label>
        </div>

      </div>


      <div class="btn-box">
        <input type="button" class="send" @click="accept" :value="$t('send')" />
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'UserListInfo',
  language: {
    'ja': {
      'page_title': '宿泊者情報確認',
      'about': '宿泊者様全員の情報をご確認のうえ、「確認しました」ボタンを押してください',

      'name': 'お名前',
      'representative': '代表者',
      'sex': '性別',
      'age': '年齢',
      'email': 'email',
      'address': 'ご住所',
      'tel': '電話番号',
      'job': 'ご職業',
      'p_dext': '前泊地',
      'n_dext': '行先地',
      'nationality': '国籍',
      'passport_no': 'パスポート番号',
      'other': 'その他(合計宿泊人数)',
      'sex1': '男',
      'sex2': '女',
      'passport_copy': 'パスポートのコピー',

      'accept_ok': 'チェックインのお手続きが完了しました',
      'revise': '修正を申請',
      'send': '確認しました',
      'back': '戻る',
    },
    'en': {
      'page_title': 'Accommodation details',

      'about': 'Please check the information of all guests and press the "Confirmed" button.',

      'name': 'Guest name\n客人姓名\n손님 이름',
      'representative': 'representative',
      'sex': 'Sex\n性别\n섹스',
      'age': 'Age\n年龄\n나이',
      'email': 'email',
      'address': 'Address\n地址\n주소',
      'tel': 'Phone number\n电话号码\n전화 번호',
      'job': 'Occupation\n占用\n직업',
      'p_dext': 'Prior Destination\n预先目的地\n이전 목적지',
      'n_dext': 'Next Destination\n下一个目的地\n다음 목적지',
      'nationality': 'Nationality\n国籍\n국적',
      'passport_no': 'Passport No.',
      'other': 'Other',
      'sex1': 'Male',
      'sex2': 'Female',
      'passport_copy': 'copy of passport\n护照复印件\n여권 사본',

      'accept_ok': 'Check-in procedure completed.',
      'revise': 'request correction',
      'send': 'Confirmed',
      'back': 'back',
    }
  },
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      customer_list: [],
      revise: false,
      lang: this.$store.getters['loginInfo/lang'],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    sex_type () {
      return ['', this.$t('sex1'), this.$t('sex2')];
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.data_get();
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get () {
      let ld = new this.$loader(this);
      ld._data_set({});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('user_customer_list_info_get.php');
    },
    data_get_cb (res) {
      this.customer_list = res.data.customer_list;
    },
    accept () {
      let ld = new this.$loader(this);
      ld._data_set({
        check_in_status: this.revise ? 2 : 1,
      });
      ld._post_cb_f = this.accept_cb;
      ld._load_start('user_customer_list_check.php');
    },
    accept_cb () {
      this.$alert('info', this.$t('accept_ok'));
      this.$router.replace({name: 'user_list_info', params: {}});
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.confirm-check-in-info-box {
  text-align: left;

  .about {
    margin-bottom: 16px;
    font-size: 14px;
  }

  .main-container {
    padding-bottom: 80px;
    .btn-box {
      width: calc(100% - 60px);
      position: fixed;
      bottom: 0px;
      display: flex;
      margin: 10px auto 0 auto;
      justify-content: center;
      padding: 10px;
      background:#d7d7dae0;

      .send {
        display: block;
        text-align: center;
        padding: 8px 8px 8px 8px;
        font-size: 16px;
        text-decoration: none;
        border-radius: 3px;
        width: 150px;
      }
    }

    .info-box {
      .user-box {
        &:not(:first-child) {
          margin-top: 32px;
        }
        .flex {
          &:last-child {
            border-bottom: 1px solid #d3d4d8;
          }
          border-top: 1px solid #d3d4d8;
          border-left: 1px solid #d3d4d8;
          border-right: 1px solid #d3d4d8;
        }
        .info-title {
          min-width: 180px;
          padding: 10px 13px 3px 3px;
          background: #fbfbfb;
          text-align: right;
          line-height: 1.5;
          border-right: 1px solid #d3d4d8;
          color: #24273b;
          white-space: pre-wrap;
        }
        img {
          width: 100%;
        }
        .info-item {
          padding: 8px;
          flex: 1;
          line-height: 1.8;
        }
      }
      .revise {
        margin: 16px 0 0 0;
        text-align: right;
        label {
          margin-right: 0;
        }
      }
    }

  }

  @media (max-width: 767px) {
    .main-container {
      .btn-box {
        width: calc(100% - 40px);
      }
      .info-box {
        .user-box {
          &:not(:first-child) {
          }
          .flex {
            display: block;
            &:last-child {
            }
          }
          .info-title {
            width: auto;
            padding: 0 0 0 8px;
            border: initial;
            text-align: left;
            font-weight: bold;
            font-size: 14px;
            line-height: 1.8;
          }
          img {
          }
          .info-item {
            padding: 0 0 0 16px;
            border: initial;
          }
        }
      }
    }
  }
}
</style>
